/* eslint-disable react-hooks/exhaustive-deps */

import React, {
  ReactElement,
  useEffect,
  useState,
  ChangeEvent,
  ReactNode,
} from 'react'
import { RichTextEditor } from '@mantine/rte'

import parse from 'html-react-parser'
import { deepFind } from 'react-children-utilities'
import { renderToString } from 'react-dom/server'
import {
  StyledTextImageAdmin,
  StyledInputs,
  StyledText,
  StyledImage,
} from './styled-components'
import Icon from '../../../icon'
import Button from '../../../button'
import Inputfield from '../../../input/input-field'
import { useAddTextAdminContext } from '../../../../contexts/add-text-admin'

interface TextAdminProps {
  id: number
  value: string
  onDeleteClick?: () => void
}

function TextImageAdmin({
  value,
  id,
  onDeleteClick,
}: TextAdminProps): ReactElement {
  const { addTextAdmin, setAddTextAdmin } = useAddTextAdminContext()
  const defaultValue = (): string[] => {
    if (value) {
      const findDiv = deepFind(
        parse(value),
        (child: ReactNode) => (child as ReactElement).type === 'div'
      )
      const textEdit1 = (findDiv as ReactElement)?.props.children[1]
      const img = (findDiv as ReactElement)?.props.children[0]
      const imgUrl = img?.props.children.props.src
        ? img?.props.children.props.src
        : ''
      const imgSize = img?.props.children.props.style.width
        ? img?.props.children.props.style.width.replace('rem', '')
        : ''
      return [renderToString(textEdit1), imgUrl, imgSize]
    }
    return ['', '']
  }

  const [text, setText] = useState<string>(defaultValue()[0])

  const [url, setUrl] = useState(defaultValue()[1])
  const [size, setSize] = useState(defaultValue()[2])

  useEffect(() => {
    setText(defaultValue()[0])
    setUrl(defaultValue()[1])
    setSize(defaultValue()[2])
  }, [])

  useEffect(() => {
    const imgToHtml = `<div class="add-image"><img src ="${url}" style=" width:${size}rem; object-fit: contain; height:auto;"/></div>`

    const textToHtml = `<div class="image-text">${imgToHtml}<div class="add-text">${text}</div></div>`

    const oldSections = [...addTextAdmin]
    const findIndexSection = oldSections.findIndex((e) => e.id === id)
    oldSections[findIndexSection].value = textToHtml
    setAddTextAdmin(oldSections)
  }, [text, url, size])

  return (
    <StyledTextImageAdmin>
      <StyledInputs>
        <StyledText>
          <RichTextEditor dir="rtl" value={text} onChange={setText} />
        </StyledText>
        <StyledImage>
          <StyledInputs>
            <Inputfield
              value={parseInt(size, 10)}
              labelName="size"
              onValueChange={(event: ChangeEvent<HTMLInputElement>) =>
                setSize(event.target.value)
              }
              type="number"
            />
            <Inputfield
              value={url}
              labelName="url"
              onValueChange={(event: ChangeEvent<HTMLInputElement>) =>
                setUrl(event.target.value)
              }
              type="text"
            />
          </StyledInputs>
        </StyledImage>
      </StyledInputs>
      <Button onClick={onDeleteClick} color="white">
        <Icon width={20} height={20} name="fluent:delete-28-regular" />
      </Button>
    </StyledTextImageAdmin>
  )
}

export default TextImageAdmin
